import * as React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ApplicantsTable from "../components/Tables/ApplicantsTable";
import PageTitles from "../components/Layout/PageTitles";

export default function Applicants() {
  return (
    <>
      <PageTitles title={"View Applicants"} />
      <Grid id="i" container spacing={3} direction="row">
        <Grid item id="j" xs>
          <Grid item id="k" sx={{ mb: 3 }}>
            <Paper
              id="l"
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ApplicantsTable />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
